var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrchestrationJob = function SvgOrchestrationJob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    fill: "#D6E3F2",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#264EA0",
    d: "M9.005 12.495c2.55 0 3.5-1.66 3.5-3.49 0-1.8-.95-3.5-3.5-3.5s-3.51 1.69-3.51 3.5c0 1.84.96 3.49 3.51 3.49Zm-1.92-3.49c0-1.47.46-2.26 1.92-2.26s1.92.79 1.92 2.26c0 1.45-.46 2.24-1.92 2.24s-1.92-.79-1.92-2.24Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    stroke: "#264EA0",
    rx: 3.5
  })));
};
export { SvgOrchestrationJob as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSIzLjUiIGZpbGw9IiNENkUzRjIiLz4KICAgIDxwYXRoIGQ9Ik05LjAwNSAxMi40OTVDMTEuNTU1IDEyLjQ5NSAxMi41MDUgMTAuODM1IDEyLjUwNSA5LjAwNTAxQzEyLjUwNSA3LjIwNTAxIDExLjU1NSA1LjUwNSA5LjAwNSA1LjUwNUM2LjQ1NSA1LjUwNSA1LjQ5NSA3LjE5NTAxIDUuNDk1IDkuMDA1MDFDNS40OTUgMTAuODQ1IDYuNDU1IDEyLjQ5NSA5LjAwNSAxMi40OTVaTTcuMDg1IDkuMDA1MDFDNy4wODUgNy41MzUgNy41NDUgNi43NDUgOS4wMDUgNi43NDVDMTAuNDY1IDYuNzQ1IDEwLjkyNSA3LjUzNSAxMC45MjUgOS4wMDUwMUMxMC45MjUgMTAuNDU1IDEwLjQ2NSAxMS4yNDUgOS4wMDUgMTEuMjQ1QzcuNTQ1IDExLjI0NSA3LjA4NSAxMC40NTUgNy4wODUgOS4wMDUwMVoiIGZpbGw9IiMyNjRFQTAiLz4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSIzLjUiIHN0cm9rZT0iIzI2NEVBMCIvPgo8L3N2Zz4K";